import FormattedMessage from 'I18n/components/FormattedMessage';
import { DAILY, MONTHLY, WEEKDAY, WEEKLY, YEARLY } from '../../constants/repeatingTasks';
import { reportNewTasksWarning } from '../../tracking/errors';
import once from 'transmute/once';
import { jsx as _jsx } from "react/jsx-runtime";
const warnOnMissingTranslation = once(freq => reportNewTasksWarning('Missing translation', {
  functionName: 'RepeatIntervalText',
  extra: freq
}));
export default function RepeatIntervalText({
  repeatInterval
}) {
  if (!repeatInterval) {
    return null;
  }
  const {
    freq,
    interval
  } = repeatInterval;
  if (typeof interval !== 'number' || interval < 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repeatingTasks.repeatsEvery.unknown"
    });
  }
  switch (freq) {
    case DAILY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repeatingTasks.repeatsEvery.day",
        options: {
          count: interval
        }
      });
    case WEEKDAY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repeatingTasks.repeatsEvery.weekday"
      });
    case WEEKLY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repeatingTasks.repeatsEvery.week",
        options: {
          count: interval
        }
      });
    case MONTHLY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repeatingTasks.repeatsEvery.month",
        options: {
          count: interval
        }
      });
    case YEARLY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repeatingTasks.repeatsEvery.year",
        options: {
          count: interval
        }
      });
    default:
      warnOnMissingTranslation(repeatInterval);
      return null;
  }
}